import React, { BaseSyntheticEvent, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useGetUrlLocale from "../../../../hooks/useGetUrlLocale";

type TModalImage = {
  src: string;
  width?: number;
  height?: number;
};

type TModalText = {
  innerText: string | ReactNode;
  className?: string;
};

interface CoreModalProps {
  show: boolean;
  onCancel?: () => void;
  title: string;
  text: TModalText;
  image: TModalImage;
}

export const CoreModal = ({
  show,
  onCancel,
  title,
  text,
  image,
}: CoreModalProps) => {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();
  const navigate = useNavigate();

  const moveToPaymentPage = () => {
    navigate(`${lng}/payment`);
    onCancel();
  };

  const closeByBackground = (e: BaseSyntheticEvent) => {
    e.stopPropagation();
    if (e.target.id === "confirmModal") onCancel();
  };

  return (
    <div
      id="confirmModal"
      className={`modal ${
        show ? "show d-flex" : ""
      } align-items-center justify-content-center`}
      style={{
        display: show ? "block" : "none",
        background: "rgb(0, 0, 0, 0.6)",
      }}
      onClick={(e) => closeByBackground(e)}
    >
      <div className="limitModal col-11" style={{ maxWidth: "500px" }}>
        <div className="modal-content text-break d-flex flex-column align-items-center">
          <div className="col-12 modal-header border-0 pb-0 pb-md-3">
            <button
              className="btn-close"
              aria-label="Close"
              onClick={onCancel}
              style={{ height: "16px", width: "16px", opacity: "1" }}
            ></button>
          </div>
          <div className="border-0 text-center d-flex flex-column align-items-center px-3 pb-3">
            <img
              className="mb-3"
              src={image.src}
              width={image?.width || ""}
              height={image?.height || ""}
              alt="limit's image"
            />
            <h4 className="fw-bold fs-24-20 text-dark mb-2 text-capitalize">
              {title}
            </h4>
            <p className={`text-dark ${text?.className || ""} fs-16-14 m-0`}>
              {text.innerText}
            </p>
          </div>
          <div className="modal-footer border-0 col-12 pb-4 flex-column">
            <button
              type="button"
              className="btn btn-primary text-white fw-bold col-12 rounded-3 py-2 py-md-3 m-0 mb-3 mb-md-4"
              onClick={moveToPaymentPage}
            >
              {t("payment.Upgrade to Premium")}
            </button>
            <p
              onClick={onCancel}
              className="d-inline text-decoration-underline text-dark fs-7 m-0 cursor-pointer"
            >
              {t("payment.Keep Free Version")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
